module.exports = {
          srcSet: __webpack_public_path__ + "95f896dcaba0a2b40c8f27c74c2b4697-66.png"+" 66w",
          images:[ {path: __webpack_public_path__ + "95f896dcaba0a2b40c8f27c74c2b4697-66.png",width: 66,height: 22}],
          src: __webpack_public_path__ + "95f896dcaba0a2b40c8f27c74c2b4697-66.png",
          toString:function(){return __webpack_public_path__ + "95f896dcaba0a2b40c8f27c74c2b4697-66.png"},
          
          width: 66,
          height: 22
        }